import Backbone from 'backbone'
import _ from 'lodash'

import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import appDisplay from 'scoreboard/components/app-display'

import template from './api-tokens-view.hbs'
import ApiTokenView from './api-token-view'
import TokenCreationDialog from './token-creation-dialog'
import permissions from 'scoreboard/components/permissions'
import DisplayHeader from 'scoreboard/components/display-header'
import i18n from 'scoreboard/components/i18n'
import currentUser from 'scoreboard/components/user'

/**
 * Main display pane showing a list of user API tokens
 */
const ApiTokensView = Backbone.View.extend({
	className: 'admin api-tokens-view table-hack scroll-layout-xy display-layout',

	/**
	 * @type ApiTokens
	 */
	collection: null,

	events: {
		'click .create-token': 'onClickCreateToken'
	},

	initialize (options = {}) {
		this.tokenViews = []
		this.users = options.users
	},

	render () {
		// If user is an app admin, show all tokens and add a new column displaying
		// who created the token.
		this.isAppAdmin = this.isAppAdmin || permissions.appAdmin()
		this.$el.empty().append(template({ createdBy: this.isAppAdmin }))

		let header = new DisplayHeader({
			heading: i18n.get('admin.apiTokens'),
			mobileGearHidden: true
		})
		this.$('.display-pane-body').before(header.el)
		header.render()

		this.collection
			.sortBy(t => t.get('createdDate'))
			.forEach(token => this.addTokenView(token))

		this.toggleEmptyState(this.collection.length < 1)
		this.covertButtonTooltips = new CovertButtonTooltips({el: this.el})
		return this
	},

	addTokenView (token) {
		let userId, createdBy
		if (this.isAppAdmin){
			userId = token.attributes.userId
			createdBy = token.attributes.createdBy ||
				this.users.find(user => user.id === userId).label
			token.attributes.createdBy = createdBy
		}
		let v = new ApiTokenView({ model: token })
		this.tokenViews.push(v)

		this.$('.api-tokens-table tbody').prepend(v.el)
		v.render()
		this.toggleEmptyState(false)

		this.listenTo(v, 'delete', () => {
			this.collection.remove(v.model)
			v.remove()
			_.pull(this.tokenViews, v)
			this.toggleEmptyState(this.collection.length < 1)
		})
	},

	onClickCreateToken () {
		this.creationView = new TokenCreationDialog()
		appDisplay.dialog(this.creationView)
		this.listenTo(this.creationView, 'create', t => {
			if (this.isAppAdmin) {
				t.attributes.createdBy = currentUser.principal.label
			}
			this.addNewToken(t)
		})
	},

	addNewToken (token) {
		this.collection.add(token, { at: 0 })
		this.addTokenView(token)
	},

	toggleEmptyState(isEmpty) {
		this.$('.empty-message').toggleClass('is-not-displayed', !isEmpty)
		this.$('.table').toggleClass('is-not-displayed', isEmpty)
	},

	autoRemove: true
})

export default ApiTokensView

ApiTokensView.__filename__ = 'admin/api-tokens/api-tokens-view.js'
